/*
Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained

access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import React, { Children } from 'react';
import css from '../css/ButtonBorder.module.css';
import { useAuthContext } from '../contexts/AuthContext';
import { useViewingContext } from '../contexts/ViewingContext';
import useScreenWidth from '../common/hooks/useScreenWidth';

const ButtonBorder = ({ children, disabled = null }) => {
  const { fullAccess } = useAuthContext();
  const { isServicerView } = useViewingContext();
  const accessGranted = (disabled !== null ? !disabled : fullAccess) || !isServicerView;

  const isDesktop = useScreenWidth('(min-width: 1025px)');

  return (
    <div className={isDesktop ? css.buttonBorder : css.buttonBorderMobile}>
      {Children.map(children, (child) => {
        if (!React.isValidElement(child)) {
          return null;
        }

        return (
          <fieldset disabled={!accessGranted}>
            <div>{React.cloneElement(child)}</div>
          </fieldset>
        );
      })}
    </div>
  );
};

export default ButtonBorder;
